import { makeAsyncActionCreators } from '../../helpers';
import { BooksActionTypes } from '../types';

const submitBookDraftToEditorByWriter = makeAsyncActionCreators(
  BooksActionTypes.submitBookDraftToEditorByWriter,
  ['bookId'],
  ['book'],
  ['error'],
);

const submitBookDraftToEditorByDevelopmentalEditor = makeAsyncActionCreators(
  BooksActionTypes.submitBookDraftToEditorByDevelopmentalEditor,
  ['bookId'],
  [],
  ['error'],
);

const sendBookDraftToCustomerByEditor = makeAsyncActionCreators(
  BooksActionTypes.sendBookDraftToCustomerByEditor,
  ['bookId'],
  ['book'],
  ['error'],
);

const approveBookDraftByCustomer = makeAsyncActionCreators(
  BooksActionTypes.approveBookDraftByCustomer,
  ['bookId'],
  ['book', 'project'],
  ['error'],
);

const sendBookDraftCustomerFeedback = makeAsyncActionCreators(
  BooksActionTypes.sendBookDraftCustomerFeedback,
  ['bookId'],
  ['book'],
  ['error'],
);

const sendBookDraftEditorFeedback = makeAsyncActionCreators(
  BooksActionTypes.sendBookDraftEditorFeedback,
  ['bookId'],
  ['book'],
  ['error'],
);

const sendBookOutlineEditorFeedback = makeAsyncActionCreators(
  BooksActionTypes.sendBookOutlineEditorFeedback,
  ['bookId', 'isUserCanRateOutline'],
  ['book'],
  ['error'],
);

const sendBookOutlineCustomerFeedback = makeAsyncActionCreators(
  BooksActionTypes.sendBookOutlineCustomerFeedback,
  ['bookId'],
  ['book'],
  ['error'],
);

const sendBookOutlineWriterFeedback = makeAsyncActionCreators(
  BooksActionTypes.sendBookOutlineWriterFeedback,
  ['bookId', 'saveCallback'],
  ['book'],
  ['error'],
);

const updateSpecificField = makeAsyncActionCreators(
  BooksActionTypes.updateSpecificField,
  ['bookId', 'field', 'value'],
  ['book'],
  ['error'],
);

const sendDraftToCustomerByWriter = makeAsyncActionCreators(
  BooksActionTypes.sendDraftToCustomerByWriter,
  ['bookId'],
  ['book'],
  ['error'],
);

const sendPDFToMyEmail = makeAsyncActionCreators(
  BooksActionTypes.sendPDFToMyEmail,
  ['bookId'],
  [],
  ['error'],
);

const saveUserIdWhoReadNotificationDraftWasEdited = makeAsyncActionCreators(
  BooksActionTypes.saveUserIdWhoReadNotificationDraftWasEdited,
  ['projectId'],
  ['book'],
  ['error'],
);

const addCommentToBookSample = makeAsyncActionCreators(
  BooksActionTypes.addCommentToBookSample,
  ['bookId', 'commentId', 'comment', 'sampleDelta'],
  ['bookId', 'comment', 'bookSample'],
  ['error'],
);

const deleteCommentInBookSample = makeAsyncActionCreators(
  BooksActionTypes.deleteCommentInBookSample,
  ['bookId', 'commentId', 'sampleDelta'],
  ['bookId', 'comment', 'bookSample'],
  ['error'],
);

const resolveCommentInBookSample = makeAsyncActionCreators(
  BooksActionTypes.resolveCommentInBookSample,
  ['bookId', 'commentId', 'sampleDelta'],
  ['bookId', 'comment', 'bookSample'],
  ['error'],
);

const updateCommentInBookSample = makeAsyncActionCreators(
  BooksActionTypes.updateCommentInBookSample,
  ['bookId', 'commentId', 'commentText'],
  ['bookId', 'comment'],
  ['error'],
);

const addReplyToCommentInBookSample = makeAsyncActionCreators(
  BooksActionTypes.addReplyToCommentInBookSample,
  ['bookId', 'commentId', 'reply'],
  ['bookId', 'commentId', 'reply'],
  ['error'],
);

const updateReplyToCommentInBookSample = makeAsyncActionCreators(
  BooksActionTypes.updateReplyToCommentInBookSample,
  ['bookId', 'commentId', 'replyId', 'replyText'],
  ['bookId', 'commentId', 'reply'],
  ['error'],
);

const deleteOrUndoComments = makeAsyncActionCreators(
  BooksActionTypes.deleteOrUndoComments,
  ['bookId', 'deltaCommentsIds', 'fieldDelta', 'fieldName'],
  ['bookId', 'comments', 'fieldName'],
  ['error'],
);

const sendPDFToPrinter = makeAsyncActionCreators(
  BooksActionTypes.sendPDFToPrinter,
  ['bookId', 'printerType', 'extraCopies'],
  ['book'],
  ['error'],
);

const getBookAndResourcesByProjectId = makeAsyncActionCreators(
  BooksActionTypes.getBookAndResourcesByProjectId,
  ['projectId'],
  ['book', 'users'],
  ['error'],
);

const getBookAndResourcesByCustomerId = makeAsyncActionCreators(
  BooksActionTypes.getBookAndResourcesByCustomerId,
  ['userId'],
  ['book', 'users'],
  ['error'],
);

const approveCoverByCustomer = makeAsyncActionCreators(
  BooksActionTypes.approveCoverByCustomer,
  ['bookId'],
  ['book'],
  ['error'],
);

const completeInterviewStage = makeAsyncActionCreators(
  BooksActionTypes.completeInterviewStage,
  ['bookId'],
  ['book'],
  ['error'],
);

const approveOutlineByEditor = makeAsyncActionCreators(
  BooksActionTypes.approveOutlineByEditor,
  ['bookId', 'isUserCanRateOutline'],
  ['book'],
  ['error'],
);

const approveOutlineByCustomer = makeAsyncActionCreators(
  BooksActionTypes.approveOutlineByCustomer,
  ['bookId'],
  ['book'],
  ['error'],
);

const submitOutlineByWriter = makeAsyncActionCreators(
  BooksActionTypes.submitOutlineByWriter,
  ['bookId', 'saveCallback'],
  ['book'],
  ['error'],
);

const approveFinalProofByCustomer = makeAsyncActionCreators(
  BooksActionTypes.approveFinalProofByCustomer,
  ['userId'],
  ['book'],
  ['error'],
);

const approveFinalProofByEditor = makeAsyncActionCreators(
  BooksActionTypes.approveFinalProofByEditor,
  ['projectId', 'editorId'],
  ['book'],
  ['error'],
);

const editorSendDraftToDevelopmentalEditor = makeAsyncActionCreators(
  BooksActionTypes.editorSendDraftToDevelopmentalEditor,
  ['bookId'],
  ['book', 'project'],
  ['error'],
);

const editorSendDraftToProProofreader = makeAsyncActionCreators(
  BooksActionTypes.editorSendDraftToProProofreader,
  ['bookId'],
  ['book', 'project'],
  ['error'],
);

const uploadDocumentToGoogleDocx = makeAsyncActionCreators(
  BooksActionTypes.uploadDocumentToGoogleDocx,
  ['bookId', 'file'],
  ['book'],
  ['error'],
);

const updateCoverCopy = makeAsyncActionCreators(
  BooksActionTypes.updateCoverCopy,
  ['bookData'],
  ['book'],
  ['error'],
);

const updateCoverOptions = makeAsyncActionCreators(
  BooksActionTypes.updateCoverOptions,
  ['bookId', 'bookData'],
  ['book'],
  ['error'],
);

const onCloseOnboardingFeedbackModal = makeAsyncActionCreators(
  BooksActionTypes.onCloseOnboardingFeedbackModal,
  ['projectId'],
  ['book'],
  ['error'],
);

const addCommentToField = makeAsyncActionCreators(
  BooksActionTypes.addCommentToField,
  ['bookId', 'commentId', 'comment', 'fieldDelta', 'fieldName'],
  ['bookId', 'comment', 'fieldDelta', 'fieldName'],
  ['error'],
);

const deleteCommentByFieldName = makeAsyncActionCreators(
  BooksActionTypes.deleteCommentByFieldName,
  ['bookId', 'commentId', 'fieldDelta', 'fieldName'],
  ['bookId', 'comment', 'fieldDelta', 'fieldName'],
  ['error'],
);

const resolveCommentByFieldName = makeAsyncActionCreators(
  BooksActionTypes.resolveCommentByFieldName,
  ['bookId', 'commentId', 'fieldDelta', 'fieldName'],
  ['bookId', 'comment', 'fieldDelta', 'fieldName'],
  ['error'],
);

const updateCommentByFieldName = makeAsyncActionCreators(
  BooksActionTypes.updateCommentByFieldName,
  ['bookId', 'commentId', 'commentText', 'fieldName'],
  ['bookId', 'comment', 'fieldName'],
  ['error'],
);

const addReplyToCommentByFieldName = makeAsyncActionCreators(
  BooksActionTypes.addReplyToCommentByFieldName,
  ['bookId', 'commentId', 'reply', 'fieldName'],
  ['bookId', 'commentId', 'reply', 'fieldName'],
  ['error'],
);

const updateReplyToCommentByFieldName = makeAsyncActionCreators(
  BooksActionTypes.updateReplyToCommentByFieldName,
  ['bookId', 'commentId', 'replyId', 'replyText', 'fieldName'],
  ['bookId', 'commentId', 'reply', 'fieldName'],
  ['error'],
);

const saveBookSampleChanges = makeAsyncActionCreators(
  BooksActionTypes.saveBookSampleChanges,
  ['bookId', 'bookSample'],
  ['book'],
  ['error'],
);

const approveBookSampleByCustomer = makeAsyncActionCreators(
  BooksActionTypes.approveBookSampleByCustomer,
  ['bookId', 'bookSample'],
  ['book'],
  ['error'],
);

const saveStyleSamplesChanges = makeAsyncActionCreators(
  BooksActionTypes.saveStyleSamplesChanges,
  ['bookId', 'styleSamples'],
  ['book'],
  ['error'],
);

const approveStyleSampleByCustomer = makeAsyncActionCreators(
  BooksActionTypes.approveStyleSampleByCustomer,
  ['bookId', 'selectedStyleSampleId'],
  ['book'],
  ['error'],
);

const approveSampleByWriter = makeAsyncActionCreators(
  BooksActionTypes.approveSampleByWriter,
  ['bookId'],
  ['book'],
  ['error'],
);

const approveSampleByEditor = makeAsyncActionCreators(
  BooksActionTypes.approveSampleByEditor,
  ['bookId'],
  ['book'],
  ['error'],
);

const submitSpecification = makeAsyncActionCreators(
  BooksActionTypes.submitSpecification,
  ['bookId', 'answers', 'structure'],
  ['book'],
  ['error'],
);

const saveSpecification = makeAsyncActionCreators(
  BooksActionTypes.saveSpecification,
  ['bookId', 'answers', 'structure'],
  ['book'],
  ['error'],
);

const uploadCustomPDF = makeAsyncActionCreators(
  BooksActionTypes.uploadCustomPDF,
  ['bookId', 'pdfUrl'],
  ['book'],
  ['error'],
);

const uploadCustomCover = makeAsyncActionCreators(
  BooksActionTypes.uploadCustomCover,
  ['bookId', 'coverUrl'],
  ['book'],
  ['error'],
);

const addCommentToPDF = makeAsyncActionCreators(
  BooksActionTypes.addCommentToPDF,
  ['bookId', 'commentText', 'pageNumber'],
  ['book'],
  ['error'],
);

const resolvePdfComment = makeAsyncActionCreators(
  BooksActionTypes.resolvePdfComment,
  ['bookId', 'commentId'],
  ['book'],
  ['error'],
);

const deletePdfComment = makeAsyncActionCreators(
  BooksActionTypes.deletePdfComment,
  ['bookId', 'commentId'],
  ['book'],
  ['error'],
);

const addReplyToPdfComment = makeAsyncActionCreators(
  BooksActionTypes.addReplyToPdfComment,
  ['bookId', 'commentId', 'replyText'],
  ['book'],
  ['error'],
);

const editPdfComment = makeAsyncActionCreators(
  BooksActionTypes.editPdfComment,
  ['bookId', 'commentId', 'commentText'],
  ['book'],
  ['error'],
);

const approveDraftByContentTeam = makeAsyncActionCreators(
  BooksActionTypes.approveDraftByContentTeam,
  ['bookId'],
  ['book', 'project'],
  ['error'],
);

const submitBookDraftToEditorByProProofreader = makeAsyncActionCreators(
  BooksActionTypes.submitBookDraftToEditorByProProofreader,
  ['bookId'],
  [],
  ['error'],
);

const proofRequestReview = makeAsyncActionCreators(
  BooksActionTypes.proofRequestReview,
  ['bookId'],
  [],
  ['error'],
);


export default {
  submitBookDraftToEditorByWriter,
  submitBookDraftToEditorByDevelopmentalEditor,
  sendBookDraftToCustomerByEditor,
  approveBookDraftByCustomer,
  sendBookDraftCustomerFeedback,
  sendBookDraftEditorFeedback,
  sendBookOutlineEditorFeedback,
  sendBookOutlineCustomerFeedback,
  sendBookOutlineWriterFeedback,
  updateSpecificField,
  sendDraftToCustomerByWriter,
  sendPDFToMyEmail,
  saveUserIdWhoReadNotificationDraftWasEdited,
  addCommentToBookSample,
  deleteCommentInBookSample,
  resolveCommentInBookSample,
  updateCommentInBookSample,
  addReplyToCommentInBookSample,
  updateReplyToCommentInBookSample,
  deleteOrUndoComments,
  sendPDFToPrinter,
  getBookAndResourcesByProjectId,
  getBookAndResourcesByCustomerId,
  approveCoverByCustomer,
  completeInterviewStage,
  approveOutlineByEditor,
  approveOutlineByCustomer,
  submitOutlineByWriter,
  approveFinalProofByCustomer,
  approveFinalProofByEditor,
  editorSendDraftToDevelopmentalEditor,
  editorSendDraftToProProofreader,
  uploadDocumentToGoogleDocx,
  updateCoverCopy,
  updateCoverOptions,
  onCloseOnboardingFeedbackModal,
  addCommentToField,
  deleteCommentByFieldName,
  resolveCommentByFieldName,
  updateCommentByFieldName,
  addReplyToCommentByFieldName,
  updateReplyToCommentByFieldName,
  saveBookSampleChanges,
  approveBookSampleByCustomer,
  saveStyleSamplesChanges,
  approveStyleSampleByCustomer,
  approveSampleByWriter,
  approveSampleByEditor,
  submitSpecification,
  saveSpecification,
  uploadCustomPDF,
  uploadCustomCover,
  addCommentToPDF,
  resolvePdfComment,
  deletePdfComment,
  addReplyToPdfComment,
  editPdfComment,
  approveDraftByContentTeam,
  submitBookDraftToEditorByProProofreader,
  proofRequestReview,
};
